import {
  useIsFetching,
  useIsMutating,
  useQueryClient,
} from '@tanstack/react-query';

export const useIsProcessingAnyRequest = () => {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const isProcessing = isFetching + isMutating > 0;

  return { isFetching, isMutating, isProcessing };
};

export const useInvalidateQuery = () => {
  const queryClient = useQueryClient();

  const invalidate = (queryKey: string, options = {}) => {
    const queryKeyArray: unknown[] = [queryKey];

    if (Object.keys(options).length > 0) {
      queryKeyArray.push(options);
    }

    queryClient.invalidateQueries({
      queryKey: queryKeyArray,
    });
  };

  return { invalidate };
};
